import { StyledContainer } from '@license-admin/boldjobs';
import { ICategoryFaqItem } from '@utils/categoryFaqGenerator';
import { useState } from 'react';
import {
  FAQAnswer,
  FAQAnswerList,
  FAQHeading,
  FAQItem,
  FAQList,
  FAQQuestion,
  FAQQuestionButton,
  FAQSection,
  FAQToggle,
} from './styled';

interface IProps {
  faqItems?: ICategoryFaqItem[];
}

const CategoryFaq = ({ faqItems = [] }: IProps) => {
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const visibleFaqItems = faqItems.filter((faqItem) =>
    faqItem.question?.trim()
  );

  if (!visibleFaqItems.length) {
    return null;
  }

  return (
    <StyledContainer>
      <FAQSection id="category-faq">
        <FAQHeading>Frequently Asked Questions</FAQHeading>
        <FAQList>
          {visibleFaqItems.map((faqItem, index) => {
            const isOpen = activeIndex === index;
            return (
              <FAQItem key={faqItem.question}>
                <FAQQuestion>
                  <FAQQuestionButton
                    type="button"
                    onClick={() => setActiveIndex(isOpen ? -1 : index)}
                    aria-expanded={isOpen}
                  >
                    {faqItem.question}
                    <FAQToggle
                      className={
                        isOpen ? 'fa-regular fa-minus' : 'fa-regular fa-plus'
                      }
                    ></FAQToggle>
                  </FAQQuestionButton>
                </FAQQuestion>

                <>
                  <FAQAnswer $isOpen={isOpen}>
                    {faqItem.answer}
                    {faqItem.answerLink && (
                      <a href={faqItem.answerLink.href}>
                        {faqItem.answerLink.label}
                      </a>
                    )}
                    {faqItem.answerLinks?.map((link, linkIndex) => (
                      <span key={link.href}>
                        {linkIndex > 0 &&
                          (linkIndex === faqItem.answerLinks!.length - 1
                            ? ', and '
                            : ', ')}
                        <a href={link.href}>{link.label}</a>
                      </span>
                    ))}
                    {faqItem.answerSuffix}
                  </FAQAnswer>
                  {faqItem.answerList && (
                    <FAQAnswerList $isOpen={isOpen}>
                      {faqItem.answerList.map((item) => (
                        <li key={item}>{item}</li>
                      ))}
                    </FAQAnswerList>
                  )}
                </>
              </FAQItem>
            );
          })}
        </FAQList>
      </FAQSection>
    </StyledContainer>
  );
};

export default CategoryFaq;
